import { DragHelper } from "../types";
export var InteropDragEvents;
(function (InteropDragEvents) {
    InteropDragEvents.EXTERNAL_DRAG_START = 'externalDragStart';
    InteropDragEvents.EXTERNAL_DRAG_END = 'externalDragEnd';
})(InteropDragEvents || (InteropDragEvents = {}));
export class DesignerInteropDragDropService {
    onDragStart(args) {
        if (args) {
            DragHelper.setExternalDragData(window, args.data);
            let event = new Event(InteropDragEvents.EXTERNAL_DRAG_START);
            window.dispatchEvent(event);
        }
        else {
            let event = new DragEvent('dragstart', { bubbles: true });
            window.dispatchEvent(event);
        }
    }
    onDragOver(args) {
        let target = this._getTargetElement(args.x, args.y);
        if (target) {
            if (target !== this._currentDropTarget) {
                let evt = new DragEvent('dragenter', { relatedTarget: target, clientX: args.x, clientY: args.y, bubbles: true });
                target.dispatchEvent(evt);
            }
            let evt = new DragEvent('dragover', { relatedTarget: target, clientX: args.x, clientY: args.y, bubbles: true });
            target.dispatchEvent(evt);
        }
        if (this._currentDropTarget && this._currentDropTarget !== target) {
            let evt = new DragEvent('dragleave', { relatedTarget: this._currentDropTarget, clientX: args.x, clientY: args.y, bubbles: true });
            this._currentDropTarget.dispatchEvent(evt);
        }
        this._currentDropTarget = target;
    }
    onDragEnter(args) {
    }
    onDragLeave(args) {
    }
    onDrop(args) {
        let target = this._getTargetElement(args.x, args.y);
        if (target) {
            let evt = new DragEvent('drop', { relatedTarget: target, clientX: args.x, clientY: args.y, bubbles: true });
            target.dispatchEvent(evt);
        }
        DragHelper.setExternalDragData(window, null);
    }
    onDragEnd() {
        let event = new Event(InteropDragEvents.EXTERNAL_DRAG_END);
        window.dispatchEvent(event);
    }
    _getTargetElement(x, y) {
        return document.elementFromPoint(x, y);
    }
}
//# sourceMappingURL=drag-drop-service.js.map